import { Navigate, useParams } from 'react-router-dom';

const VaultsItemRedirect = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/market-details/${id ?? ''}`} replace />;
};

export default VaultsItemRedirect;
